import { useEffect, useRef } from 'react';
import moment from 'moment';

export default function RegisterStat({
  endpoint = '/register',
  site,
  app,
  module: mod,
  date,
  time,
  useUTC = false,
  headers = {}
}) {
  const sent = useRef(false); // stays true for the life of this component instance

  useEffect(() => {
    if (sent.current) return; // skip if already sent in this mount
    sent.current = true;

    const now = useUTC ? moment.utc() : moment();
    const body = {
      site: String(site),
      app: String(app),
      module: String(mod),
      date: date || now.format('YYYY-MM-DD'),
      time: time || now.format('HH:mm:ss'),
    };

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...headers },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(console.error);
  }, [endpoint, site, app, mod, date, time, useUTC, headers]);

  return null;
}
